export default "__VITE_ASSET__mLRk2k0X__"